module.exports = __webpack_public_path__ + "img/年货礼包and旺旺大礼包.f77f4972.jpg";